import { ExploreBanner, ExploreList } from "@modules/study/explore";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import React from "react";

const Explore = ({ allExploreData }) => {
  return (
    <LayoutMain title="Explore University">
      <ExploreBanner
        title="Explore University"
        description="There’s a perfect university out there for every student. And
              we’re here to help you find yours. UniSearch brings together
              universities and institutions from major study abroad destinations
              to a single place - right here! Explore the options available to
              you, using our intuitive filters to shortlist the study abroad
              choices best matching your requirements. Our AI-powered search
              engine helps you turn hours of unproductive research into a matter
              of minutes, with precise, personalised results to give you that
              definitive head start toward your dream university."
        metaUrl={`${process.env.NEXT_PUBLIC_URL}/explore-university`}
      />
      <ExploreList allExploreData={allExploreData} />
    </LayoutMain>
  );
};

export default Explore;

export async function getServerSideProps() {
  let props = {
    allExploreData: [],
  };

  try {
    await API.get(
      `/public/university/explore-university?isTop=true&page=1`
    ).then((resp) => {
      if (!resp.error && resp.data) {
        props.allExploreData = resp.data;
      } else {
        props.allExploreData = "";
      }
    });

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
